<template>
  <div>
    <el-upload
      class="avatar-uploader"
      :action="''"
      :show-file-list="false"
      :auto-upload="false"
      :on-change="getUrl"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      imageUrl: "",
    };
  },

  methods: {
    // 上传图片
    getUrl(file, fileList) {
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt2M = file.raw.size / 1024 / 1024 < 0.5;
      this.hideUploadIcon = fileList.length >= 1;
      if (!isPNG && !isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 200kb!");
        return false;
      } else if (isLt2M && (isPNG || isJPG)) {
        this.imageUrl = URL.createObjectURL(file.raw); //图片的url
        this.getBase64(file.raw).then((res) => {
          // 这里是图片的Base64结果
         this.$emit("picResult",res)
        });
      }
    },

      getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
  },
};
</script>


<style lang="scss" scope>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>